// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "react-syntax-highlighter/refractor-import" + "." + "f8a99b75" + ".chunk.js";
};